<template>
  <div class="layout-main">
    <div class="layout-main-wrapper">
      <slot></slot>
      <LayoutFloat />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import LayoutFloat from "./Float.vue";
export default defineComponent({
  name: "LayoutMain",
  components: { LayoutFloat },
  setup() {
    return {};
  },
});
</script>

<style lang="scss" scoped>
.layout-main {
  min-width: 950px;
  margin-left: 210px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .layout-main-wrapper {
    width: 100%;
  }
}
</style>
